import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router";
import { StoreProvider } from "./store/StoreProvider";

import ProtectedRoutes from "./utils/ProtectedRoutes";
import ProtectedAdminRoutes from "./utils/ProtectedAdminRoutes";
import LoginPage from "./pages/LoginPage/LoginPage";
import SchedulePage from "./pages/SchedulePage/SchedulePage";
import Patients from "./pages/PatientsPage/PatientsPage";
import PatientDetailsPage from "./pages/PatientDetailsPage/PatientDetailsPage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import AppointmentsPage from "./pages/AppointmentsPage/AppointmentsPage";
import AppointmentDetailsPage from "./pages/AppointmentDetailsPage/AppointmentDetailsPage";
import Statistic from "./pages/Statistic/Statistic";
import UsersPage from "./pages/UsersPage/UsersPage";
import UserDetailsPage from "./pages/UserDetailsPage/UserDetailsPage";
import Spinner from "./components/Spinner/Spinner";
import ToastMessage from "./components/ToastMessage/ToastMessage";

import "./styles.css";

const root = ReactDOM.createRoot(
    document.getElementById("root") as HTMLElement,
);
root.render(
    <StoreProvider>
        <BrowserRouter>
            <Spinner />
            <ToastMessage />
            <Routes>
                <Route path='/' element={<LoginPage />} />
                <Route element={<ProtectedRoutes />}>
                    <Route path='/schedule' element={<SchedulePage />} />
                    <Route path='/patients' element={<Patients />} />
                    <Route
                        path='/patients/:id'
                        element={<PatientDetailsPage />}
                    />
                    <Route
                        path='/appointments'
                        element={<AppointmentsPage />}
                    />
                    <Route
                        path='/appointments/:id'
                        element={<AppointmentDetailsPage />}
                    />

                    <Route element={<ProtectedAdminRoutes />}>
                        <Route path='/services' element={<ServicesPage />} />
                        <Route path='/users' element={<UsersPage />} />
                        <Route
                            path='/users/:id'
                            element={<UserDetailsPage />}
                        />
                        <Route path='/statistic' element={<Statistic />} />
                    </Route>
                </Route>
            </Routes>
        </BrowserRouter>
    </StoreProvider>,
);
